import React from 'react';

import { useUIContext } from 'state/ui';

import { Price, PriceAndCaloriesWrapper } from './styled';
import { PriceAndCaloriesProps } from './types';

export const PriceAndCalories: React.FC<React.PropsWithChildren<PriceAndCaloriesProps>> = ({
  price,
  calories,
}) => {
  const { formatCurrencyForLocale } = useUIContext();

  if (!price && !calories) {
    return null;
  }

  const formattedPriceSign = price && price > 0 ? '+' : '';
  const formattedPrice = price && `${formattedPriceSign}${formatCurrencyForLocale(price)}`;

  return (
    <PriceAndCaloriesWrapper>
      {/* @TODO BKPE-9294: Hide Calories until we decide to show them  */}
      {/* <CaloriesText accessibilityLabel={`${formattedPrice || ''} ${calories}`}>
        {calories}
      </CaloriesText> */}
      {!!formattedPrice && <Price>{formattedPrice}</Price>}
    </PriceAndCaloriesWrapper>
  );
};
